import WorkOrder from '../models/WorkOrder';
import TreatmentRecord from '../models/TreatmentRecord';
import TreatmentRecordService from './TreatmentRecordService';

const STORAGE_KEY = 'workOrders';

const WorkOrderService = {
  /**
   * Get all work orders
   * @returns {WorkOrder[]}
   */
  getAllWorkOrders() {
    const data = localStorage.getItem(STORAGE_KEY);
    if (!data) return [];
    return JSON.parse(data).map(WorkOrder.fromJSON);
  },

  /**
   * Get work orders by appointmentId
   * @param {string} appointmentId
   * @returns {WorkOrder[]}
   */
  getWorkOrdersByAppointmentId(appointmentId) {
    return this.getAllWorkOrders().filter(order => order.appointmentId === appointmentId);
  },

  /**
   * Get work order by id
   * @param {string} id
   * @returns {WorkOrder|null}
   */
  getWorkOrderById(id) {
    return this.getAllWorkOrders().find(order => order.id === id) || null;
  },

  /**
   * Create a new work order and auto-create a treatment record
   * @param {Object} data
   * @returns {WorkOrder}
   */
  createWorkOrder(data) {
    const orders = this.getAllWorkOrders();
    const newOrder = new WorkOrder(data);
    orders.push(newOrder);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(orders.map(o => o.toJSON())));

    // Auto-create a treatment record and link it
    const treatmentRecord = TreatmentRecordService.createTreatmentRecord({
      appointmentId: newOrder.appointmentId,
      customerId: newOrder.customerId,
      practitionerId: newOrder.practitionerId,
      workOrderId: newOrder.id,
      treatmentProjectId: newOrder.treatmentProjectId,
      treatmentProjectName: newOrder.treatmentProjectName
    });
    this.linkTreatmentRecord(newOrder.id, treatmentRecord.id);

    return this.getWorkOrderById(newOrder.id);
  },

  /**
   * Update a work order
   * @param {string} id
   * @param {Object} data
   * @returns {WorkOrder|null}
   */
  updateWorkOrder(id, data) {
    const orders = this.getAllWorkOrders();
    const idx = orders.findIndex(order => order.id === id);
    if (idx === -1) return null;
    orders[idx].update(data);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(orders.map(o => o.toJSON())));
    return orders[idx];
  },

  /**
   * Link a treatment record to a work order
   * @param {string} workOrderId
   * @param {string} treatmentRecordId
   */
  linkTreatmentRecord(workOrderId, treatmentRecordId) {
    this.updateWorkOrder(workOrderId, { treatmentRecordId });
    // 同步更新调理记录的 workOrderId 字段
    TreatmentRecordService.updateTreatmentRecord && TreatmentRecordService.updateTreatmentRecord(treatmentRecordId, { workOrderId });
  },

  callNumber(workOrderId, { operatorId, treatmentRecordId, type = 'call', note = '' }) {
    const workOrder = this.getWorkOrderById(workOrderId);
    if (workOrder) {
      workOrder.callNumber({ operatorId, treatmentRecordId, type, note });
      this.updateWorkOrder(workOrder.id, workOrder.toJSON());
    }
  }
};

export default WorkOrderService; 